import { ColorTypes, RadiusTypes, SpacingTypes } from '@folx-types/theme';
import { FC } from 'react';
import styled, { DefaultTheme, IntrinsicElementsKeys, StyledComponent } from 'styled-components';

import theme from '@theme/FolxTheme';

interface IRounded {
	borderRadius: RadiusTypes;
	outlineColor?: ColorTypes;
	outlineWidth?: SpacingTypes;
}

const rounded = <U>(
	component: StyledComponent<IntrinsicElementsKeys | FC<U>, DefaultTheme> | IntrinsicElementsKeys
) =>
	styled<StyledComponent<IntrinsicElementsKeys | FC<U>, DefaultTheme> | IntrinsicElementsKeys>(
		component
	)<IRounded>`
		border-radius: ${({ borderRadius }) => theme.radius[borderRadius]};
		outline: ${({ outlineWidth = 'one', outlineColor = 'black' }) =>
			`${theme.spacing[outlineWidth]} solid ${theme.colors[outlineColor]}`};
	`;

export default rounded;
